import { sanitizeForLog } from '../constants/index'
import {
  BASE_URL,
  CREATE_SECTION_KEYWORD_API,
  DELETE_SECTION_KEYWORD_API,
  DOWNLOAD_EXCEL_SECTION_KEYWORD_API,
  GET_SECTION_DROPDOWN_LIST_API,
  GET_SECTION_KEYWORD_LIST_API,
  UPDATE_SECTION_KEYWORD_API,
} from '../endpoints/apiEndpoints'
import { getAccessToken } from '../utils/session'
import {
  buildRequestHeader,
  handleErrorResponse,
  handleRequestFailure,
  handleSuccessResponse,
  urlBuilder,
} from './apiUtils'

export const createSectionKeyword = async payload => {
  const url = urlBuilder(CREATE_SECTION_KEYWORD_API)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export async function updateSectionKeyword(sectionKeywordData, keywordId) {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')
  const url = urlBuilder(UPDATE_SECTION_KEYWORD_API, { keywordId })
  const requestHeader = buildRequestHeader('PUT', sectionKeywordData, {
    Authorization: `Bearer ${accessToken}`,
    Accept: '*/*',
  })
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

// get section keywords dropdown

export const getSectionDropdown = async payload => {
  try {
    const token = getAccessToken()
    const apiUrl = `${BASE_URL}/${GET_SECTION_DROPDOWN_LIST_API}`
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payload),
    }
    const response = await fetch(apiUrl, requestOptions)
    if (!response.ok) {
      let errorMessage
      try {
        const errorData = await response.json()
        errorMessage =
          errorData.message || `Request failed with status: ${response.status}`
      } catch {
        errorMessage = `Request failed with status: ${response.status}`
      }
      throw new Error(errorMessage)
    }
    const data = await response.json()
    return {
      success: true,
      data,
    }
  } catch (error) {
    console.error('Failed to Assign Entity to User:')
    return {
      success: false,
      error: error.message || 'Failed to Assign Entity to User',
    }
  }
}

export async function getSectionKeywordsList(payload, tanMasterId) {
  const defaultPayload = {
    pageFilter: {
      currentPage: 1,
      includeCount: true,
      pageSize: 100,
      sortField: 'sectionKeyword',
      sortOrder: 'ASC',
    },
    requestFilter: [],
    isReportDownload: false,
    searchCOList: [],
  }

  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')

  const res = await fetch(
    `${BASE_URL}/${GET_SECTION_KEYWORD_LIST_API}/${tanMasterId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload ? payload : defaultPayload),
    }
  )

  if (!res.ok) throw new Error(`Failed to fetch TAN list: ${res.status}`)
  return await res.json()
}

export async function downloadSectionKeywordsExcel(payload) {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')

  const res = await fetch(`${BASE_URL}/${DOWNLOAD_EXCEL_SECTION_KEYWORD_API}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  })

  if (!res.ok)
    throw new Error(`Failed to download TAN Master Excel: ${res.status}`)

  // Return as Blob (Excel file)
  const blob = await res.blob()
  return blob
}

export const deleteSectionKeyword = async (tanMasterId, uuid) => {
  try {
    const token = getAccessToken()
    const apiUrl = `${BASE_URL}/${DELETE_SECTION_KEYWORD_API}/${tanMasterId}/${uuid}`
    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    }
    const response = await fetch(apiUrl, requestOptions)

    if (!response.ok) {
      let errorMessage
      try {
        const errorData = await response.json()
        errorMessage =
          errorData?.data ||
          errorData?.errors[0]?.message ||
          `Request failed with status: ${response?.status}`
      } catch {
        errorMessage = `Request failed with status: ${response.status}`
      }
      throw new Error(errorMessage)
    }
    const data = await response.json()
    // If API uses business-level success flag, handle it
    if (data && data.success === false) {
      const errorMessage =
        data.message ||
        (Array.isArray(data.errors) &&
          data.errors[0] &&
          data.errors[0].message) ||
        'Request failed'
      return {
        success: false,
        error: errorMessage,
        data,
      }
    }
    return {
      success: true,
      data,
    }
  } catch (error) {
    console.error(
      'Failed to create Rule Setting:',
      sanitizeForLog(error?.message || 'Unknown error')
    )
    return {
      success: false,
      error: error?.message || 'Failed to create Rule Setting',
    }
  }
}
